var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-h4 mb-10"},[_c('div',[_vm._v("Alterar senha")]),_c('UpdatePasswordForm')],1)}
var staticRenderFns = []

export { render, staticRenderFns }